enum Languages {
  Spanish = 'es',
  English = 'en'
}

export default Languages;